import React from "react";
import LegalLayout from "../LegalLayout";

export default function Confidentialite() {
  return (
    <LegalLayout testid="confidentialite-page" eyebrow="Confidentialité" title="Politique de confidentialité" lastUpdate="14 octobre 2026">
      <h2>Acta Documentum — Projet Ego Automata</h2>
      <p>
        Acta Documentum est une application développée dans le cadre du projet
        entrepreneurial <strong>Ego Automata</strong>, actuellement en cours de création.
        L'application est testée dans un cadre privé par des salariés et prestataires
        travaillant pour <strong>LIRAH SAS</strong>. Alma France est une société envisagée,
        non encore constituée.
      </p>
      <p>
        Les tests impliquent des données réelles de comptes utilisateurs, de clients,
        de prospects et des informations professionnelles. Les informations détaillées
        relatives aux traitements, à leur conservation et à leur protection restent
        en cours de vérification ; ce caractère provisoire ne suspend pas les droits
        des personnes concernées.
      </p>
      <h2>Données traitées dans l'application</h2>
      <p>
        Selon les fonctionnalités utilisées, Acta Documentum traite notamment
        des données de compte, des contacts professionnels, des documents,
        des messages et des événements liés aux consultations de documents partagés.
      </p>
      <p>
        Les ouvertures et durées de consultation des documents partagés peuvent
        être liées à un prospect. La suppression de la collecte d'adresse IP
        dans les événements de partage concernés ne rend pas ces données anonymes.
      </p>
      <h2>Exercer vos droits</h2>
      <p>
        Vous pouvez demander des informations sur les traitements vous concernant
        et exercer les droits applicables prévus par le RGPD en écrivant à
        {" "}<a href="mailto:contact@acta-documentum.fr">contact@acta-documentum.fr</a>.
        Vous pouvez également adresser une réclamation à la
        {" "}<a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">CNIL</a>.
      </p>
      <p>
        LIRAH SAS est l'entreprise utilisatrice actuelle. L'identité du responsable
        de chaque traitement doit être confirmée en fonction des décisions effectives.
        Les finalités, bases légales, destinataires, durées de conservation et éventuels
        transferts doivent encore être précisés.
      </p>
    </LegalLayout>
  );
}
